module.exports = __webpack_public_path__ + "7f1de9347a7184f793da69e5604e2b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/bwlogo.png
// module id = 1283
// module chunks = 10